import { render } from "./SearchBookModal.vue?vue&type=template&id=9db84fa8"
import script from "./SearchBookModal.vue?vue&type=script&lang=js"
export * from "./SearchBookModal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\ef_vue_icecreator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__